<view-charges-mobile
  *ngIf="isMobile$ | async"
  [masterGroups]="MASTER_GROUPS"
  [secondaryGroups]="SECONDARY_GROUPS"
  [totalSum]="totalSum"
  [isPaid]="isPayed"
  [totalFieldKey]="totalFieldKey"
></view-charges-mobile>

<div class="table-wrapper" *ngIf="!(isMobile$ | async)">
  <table>
    <thead>
      <tr class="bordered-bottom">
        <th>
          <h3>{{ headerFieldKey | translate }}</h3>
        </th>

        <th>
          {{ "LABELS.QTY" | translate }}
        </th>

        <th>
          {{ "LABELS.RATE_CHARGES" | translate }}
        </th>

        <th>
          {{ "LABELS.AMOUNT" | translate }}
        </th>
      </tr>
    </thead>

    <tbody>
      <ng-container *ngFor="let products of MASTER_GROUPS">
        <tr *ngIf="showCategories" class="master-product-header">
          <td colspan="3" class="master-product-header__title">
            <span>{{ "LABELS." + products.key | translate }}</span>
          </td>
          <td class="master-product-header__price">
            {{ getSumMasterGroup(products.items) | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </td>
        </tr>

        <tr *ngFor="let bill of products.items" class="master-product-list">
          <td>
            {{ bill.description }}
          </td>
          <td>{{ bill?.internalQuantities?.quantity }} {{ itemQuantityLabel(bill?.internalQuantities?.unit) | translate }}</td>
          <td>{{ bill?.price / bill?.internalQuantities?.quantity || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</td>
          <td>
            {{ bill?.price || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </td>
        </tr>

        <tr *ngFor="let bill of discountBillItems(products.items)" class="master-product-list discount">
          <td>
            {{ bill.description }}
          </td>
          <td></td>
          <td></td>
          <td>
            {{ discountBillItemsValue(products.items) | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </td>
        </tr>
      </ng-container>
      <ng-container *ngFor="let group of SECONDARY_GROUPS">
        <tr *ngIf="showCategories" class="master-product-header">
          <td colspan="3" class="master-product-header__title">
            <span>{{ "LABELS." + group.key | translate }}</span>
          </td>
          <td class="master-product-header__price" [ngClass]="{ 'master-product-header__price-deductions': group.key === 'DEDUCTIONS' }">
            {{ getSumAdditionalGroup(group.items) | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </td>
        </tr>

        <tr *ngFor="let bill of group.items" class="master-product-list">
          <td>
            {{ isShowDescription(bill.productCode) ? bill.description : bill.notes }}
          </td>
          <td>{{ bill.quantity }}</td>
          <td>{{ bill?.price || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</td>
          <td>
            {{ bill?.price * bill?.quantity || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </td>
        </tr>

        <tr *ngFor="let bill of discountBillItems(group.items)" class="master-product-list discount">
          <td>
            {{ bill.description }}
          </td>
          <td></td>
          <td></td>
          <td>
            {{ discountBillItemsValue(group.items) | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </td>
        </tr>
      </ng-container>
    </tbody>
    <tfoot class="bordered-top">
      <tr>
        <td colspan="3">
          <h3>{{ totalFieldKey | translate : { field: "" } }}</h3>
        </td>
        <td class="sum">
          <div class="d-flex align-items-center justify-content-end">
            <span class="payment-label payed" *ngIf="isPayed">
              <i class="fa fa-check mr-1"></i>
              {{ "LABELS.PAID" | translate }}
            </span>
            {{ totalSum | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
